import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WebModulosTextos } from '../models/webModulosTextos.model';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { ViewModelDadosModulos } from '../models/ViewModelDadosModulos.model';
import { ViewModelDadosInstitutos } from '../models/ViewModelDadosInstitutos.model';
import { ViewModelFiltroWebModulosTextos } from '../models/viewModelFiltroWebModulosTextos.model';
import { ViewModelProcessoWebModulosTextos } from '../models/ViewModelProcessoWebModulosTextos.model';

@Injectable({
    providedIn: 'root'
})
export class WebModulosTextosService {



    constructor(private http: HttpClient) {

    }

    RetornaListaComboInstitutosService(): Observable<ViewModelDadosInstitutos[]> {
        return this.http.get<ViewModelDadosInstitutos[]>(`${environment.TrustCRMApiHost}api/WebModulosTextos/retornaListaComboInstitutos`);
    }
    RetornaListaComboModulos(): Observable<ViewModelDadosModulos[]> {
        return this.http.get<ViewModelDadosModulos[]>(`${environment.TrustCRMApiHost}api/WebModulosTextos/retornaListaComboModulos`);
    }

    RetornaListaFiltroInstitudo(idModulo: number, idPlano: number): Observable<ViewModelDadosModulos[]> {
        return this.http.get<ViewModelDadosModulos[]>(`${environment.TrustCRMApiHost}api/WebModulosTextos/retornaFiltroInstitutos?idModulo=${idModulo}&idPlano=${idPlano}`);
    }
    
    Criar(webModulosTextos: WebModulosTextos): Observable<WebModulosTextos[]> {
        return this.http.post<WebModulosTextos[]>(`${environment.TrustCRMApiHost}api/WebModulosTextos/Criar`, webModulosTextos);

    }

    PostFiltroDesligados(viewModelFiltroWebModulosTextos: ViewModelFiltroWebModulosTextos): Observable<ViewModelProcessoWebModulosTextos[]> {
        return this.http.post<ViewModelProcessoWebModulosTextos[]>(`${environment.TrustCRMApiHost}api/WebModulosTextos/PostFiltroModulosTextos`, viewModelFiltroWebModulosTextos);

    }

    excluir(idSeq: number) {
        return this.http.post<any>(`${environment.TrustCRMApiHost}api/WebModulosTextos/DeleteById?id=${idSeq}`, '');
    }

    editar(webModulosTextos: WebModulosTextos): Observable<WebModulosTextos[]> {
        return this.http.post<WebModulosTextos[]>(`${environment.TrustCRMApiHost}api/WebModulosTextos/Put`, webModulosTextos);

    }

}
